import React, {FC, ReactNode} from "react";
import {EventType, StayDataType} from "data/types";
import EventShopCard from "components/EventShopCard/EventShopCard";

export interface SectionGridFeaturePropertyProps {
  stayListings?: StayDataType[];
  gridClass?: string;
  heading?: ReactNode;
  subHeading?: ReactNode;
  headingIsCenter?: boolean;
  tabs?: string[];
  events: EventType[];
}

const SectionEventsShop: FC<SectionGridFeaturePropertyProps> = ({
  gridClass = "",
  events,
}) => {
  const renderCard = (event: EventType, index: number) => {
    return <EventShopCard key={index} className="h-full" data={event} />;
  };

  return (
    <div className="nc-SectionGridFeatureProperty relative">
      {events.length === 0 && (
        <div className="w-full p-6">
          <p className="text-center">No se encontraron eventos.</p>
        </div>
      )}
      <div
        className={`grid gap-6 md:gap-8 grid-cols-1 sm:grid-cols-1 xl:grid-cols-2 ${gridClass}`}
      >
        {events?.map((item, index) => (
          <div key={index} className="w-full">
            {renderCard(item, index)}
          </div>
        ))}
      </div>
      {/* <div className="flex mt-16 justify-center items-center">
        <ButtonPrimary>Ver más</ButtonPrimary>
      </div> */}
    </div>
  );
};

export default SectionEventsShop;
